import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {HttpClient} from '@angular/common/http';

import {CommonUtility, ServerConstantsService} from './shared';
import {NotificationsService} from 'angular2-notifications';


@Injectable()
export class ReferenceTableService {

  private messageSource = new BehaviorSubject<any>('');
  currentMessage = this.messageSource.asObservable();
  userActionNotificationsMap: any;
  ServerConstants: any;

  private messageSourceReadOnly = new BehaviorSubject<any>('');
  currentMessageReadOnly = this.messageSourceReadOnly.asObservable();

  private sharedDataMap = new Map<string, string>();

  constructor(
    private http: HttpClient,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private commonUtil: CommonUtility,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.loadData();
  }

  firstName = new BehaviorSubject<any>('');
  currentFirstName = this.firstName.asObservable();

  /* get static data */
   loadData() {
    this.firstName.next(sessionStorage.getItem("FirstName"));
      this.http.get<any>(this.ServerConstants.SERVER_API_URL + "/staticData/load").subscribe(
      (val) => {
        const refDataReadOnly = Object.assign({}, val);
        this.messageSourceReadOnly.next(refDataReadOnly);
        //Add "Pick an Option" to all reference table
        const date = new Date();

        date.setHours(23, 59, 59, 99);


        for (const obj in val.englishDropDown) {
          val.englishDropDown[obj].unshift({
            "name": "Pick an option", "value": undefined,
            "activeSW": "Y", "activeBeginDt": date
          });
          const items = val.englishDropDown[obj];

          for (let index = 0; index < items.length; index++) {
            if (items[index]=== null || items[index]=== undefined || (items[index].activeSW !== 'Y' || items[index].activeBeginDt === undefined
              || (new Date(items[index].activeBeginDt)).getTime() > date.getTime())) {
              items.splice(index, 1);
              index--;
            }
          }
        }

        for (const obj in val.spanishDropDown) {
          val.spanishDropDown[obj].unshift({
            "name": "Pick an option", "value": undefined, "activeSW": "Y",
            "activeBeginDt": date
          });
          const items = val.spanishDropDown[obj];
          for (let index = 0; index < items.length; index++) {
            if (items[index]=== null || items[index]=== undefined || (items[index].activeSW !== 'Y' || items[index].activeBeginDt === undefined
              || (new Date(items[index].activeBeginDt)).getTime() > date.getTime())) {
              items.splice(index, 1);
              index--;
            }
          }
        }
        this.messageSource.next(val);
        //return object
      },
      response => {
        console.log("Get call in error", response);
      },
      () => {

      }
    );

    this.currentMessage.subscribe(refData => {
      this.parseRefTableData(refData);
    });
  }

  parseRefTableData(myData) {

    if (myData !== undefined && myData.englishDropDown) {
      /* For dropdowns */
      this.addValueToSharedDataMap("USER-ACTION-NOTIFICATIONS",myData.englishDropDown['USER-ACTION-NOTIFICATIONS']);

      this.addValueToSharedDataMap("PROGRAMS",myData.englishDropDown['PROGRAMS']);
      this.addValueToSharedDataMap("TASKSTATUS",myData.englishDropDown['TASKSTATUS']);
      this.addValueToSharedDataMap("TASKTYPES",myData.englishDropDown['TASKTYPES']);
      this.addValueToSharedDataMap("DISABLETASKTYPES",myData.englishDropDown['DISABLETASKTYPES']);
      this.addValueToSharedDataMap("TASKDUEDATES" ,myData.englishDropDown['TASKDUEDATES']);
      this.addValueToSharedDataMap("COUNTIES",myData.englishDropDown['COUNTIES']);
      this.addValueToSharedDataMap("ariesCounties",myData.englishDropDown['ariesCounties']);
      this.addValueToSharedDataMap("AREA I",myData.englishDropDown['AREA I']);
      this.addValueToSharedDataMap("AREA II",myData.englishDropDown['AREA II']);
      this.addValueToSharedDataMap("AREA III",myData.englishDropDown['AREA III']);
      this.addValueToSharedDataMap("AREA IV",myData.englishDropDown['AREA IV']);
      this.addValueToSharedDataMap("AREA V",myData.englishDropDown['AREA V']);
      this.addValueToSharedDataMap("AREA VI",myData.englishDropDown['AREA VI']);
      this.addValueToSharedDataMap("AUDIENCES",myData.englishDropDown['AUDIENCES']);
      this.addValueToSharedDataMap("ASSIGNEDTO",myData.englishDropDown['ASSIGNEDTO']);
      this.addValueToSharedDataMap("APPOINTMENTTYPE",myData.englishDropDown['APPOINTMENTTYPE']);
      this.addValueToSharedDataMap("REPORT_NAME",myData.englishDropDown['REPORT_NAME']);
      /* Non-Compliance*/
      this.addValueToSharedDataMap("goodCauseVerification",myData.englishDropDown['goodCauseVerification']);
      this.addValueToSharedDataMap("goodCauseReason",myData.englishDropDown['goodCauseReason']);
      this.addValueToSharedDataMap("MONTHS",myData.englishDropDown['MONTHS']);
      this.addValueToSharedDataMap("NonCompReasonDesc",myData.englishDropDown['NonCompReasonDesc']);
      this.addValueToSharedDataMap("GoodCauseReasonDesc",myData.englishDropDown['GoodCauseReasonDesc']);
      this.addValueToSharedDataMap("ProgramName",myData.englishDropDown['ProgramName']);

      this.addValueToSharedDataMap("failedToComplyNC",myData.englishDropDown['failedToComplyNC']);
      this.addValueToSharedDataMap("YESNO",myData.englishDropDown['YESNO']);
      this.addValueToSharedDataMap("SkillTypeDesc",myData.englishDropDown['SkillTypeDesc']);
      this.addValueToSharedDataMap("HSGradYear",myData.englishDropDown['HSGradYear']);
      this.addValueToSharedDataMap("StrengthTypeDesc",myData.englishDropDown['StrengthTypeDesc']);
      this.addValueToSharedDataMap("LicenseCertificateTypeDesc",myData.englishDropDown['LicenseCertificateTypeDesc']);
      this.addValueToSharedDataMap("EducationLevelDesc",myData.englishDropDown['EducationLevelDesc']);

      this.addValueToSharedDataMap("AssessmentStatusDesc",myData.englishDropDown['AssessmentStatusDesc']);
      this.addValueToSharedDataMap("HighestEducationNameDesc",myData.englishDropDown['HighestEducationNameDesc']);
      this.addValueToSharedDataMap("FederalLicense",myData.englishDropDown['FederalLicense']);
      this.addValueToSharedDataMap("StateLicense",myData.englishDropDown['StateLicense']);
      this.addValueToSharedDataMap("ProfessionalCertification",myData.englishDropDown['ProfessionalCertification']);
      this.addValueToSharedDataMap("TechnicalCertification",myData.englishDropDown['TechnicalCertification']);
      this.addValueToSharedDataMap("TestTypeDesc",myData.englishDropDown['TestTypeDesc']);

      this.addValueToSharedDataMap("BarrierTypeDesc",myData.englishDropDown['BarrierTypeDesc']);
      this.addValueToSharedDataMap("FamilyBarrierNameDesc",myData.englishDropDown['FamilyBarrierNameDesc']);
      this.addValueToSharedDataMap("PersonalBarrierNameDesc",myData.englishDropDown['PersonalBarrierNameDesc']);
      this.addValueToSharedDataMap("TransportationBarrierNameDesc",myData.englishDropDown['TransportationBarrierNameDesc']);
      this.addValueToSharedDataMap("JobStatusDesc",myData.englishDropDown['JobStatusDesc']);
      this.addValueToSharedDataMap("ReasonLeavingJobDesc",myData.englishDropDown['ReasonLeavingJobDesc']);

      this.addValueToSharedDataMap("GENDER",myData.englishDropDown['GENDER']);
      this.addValueToSharedDataMap("LANGUAGES",myData.englishDropDown['LANGUAGES']);
      this.addValueToSharedDataMap("CONTACTMETHODS",myData.englishDropDown['CONTACTMETHODS']);

      this.addValueToSharedDataMap("ContactMethod",myData.englishDropDown['ContactMethod']);

      this.addValueToSharedDataMap("ContactReason",myData.englishDropDown['ContactReason']);
      this.addValueToSharedDataMap("ContactOutcome",myData.englishDropDown['ContactOutcome']);

      this.addValueToSharedDataMap("appointmentType",myData.englishDropDown['appointmentType']);
      this.addValueToSharedDataMap("appointmentStatus",myData.englishDropDown['appointmentStatus']);
      this.addValueToSharedDataMap("appointmentMethod",myData.englishDropDown['appointmentMethod']);
      this.addValueToSharedDataMap("appointmentLocation",myData.englishDropDown['appointmentLocation']);

      this.addValueToSharedDataMap("EmploymentType",myData.englishDropDown['EmploymentType']);
      this.addValueToSharedDataMap("EmpPlanStatusDesc",myData.englishDropDown['EmpPlanStatusDesc']);


      this.addValueToSharedDataMap("RELATIONSHIP",myData.englishDropDown['RELATIONSHIP']);
      this.addValueToSharedDataMap("WORKPARTSTATUS",myData.englishDropDown['WORKPARTSTATUS']);
      this.addValueToSharedDataMap("OTHERCHARACTERISTICS",myData.englishDropDown['OTHERCHARACTERISTICS']);

      this.addValueToSharedDataMap("PRIORITY",myData.englishDropDown['PRIORITY']);
      this.addValueToSharedDataMap("COMPONENTS",myData.englishDropDown['COMPONENTS']);
      this.addValueToSharedDataMap("METPLAN",myData.englishDropDown['METPLAN']);
      this.addValueToSharedDataMap("CountableHoursDesc",myData.englishDropDown['CountableHoursDesc']);
      this.addValueToSharedDataMap("ComponentMaxAuthorizedHrsDesc",myData.englishDropDown['ComponentMaxAuthorizedHrsDesc']);

      this.addValueToSharedDataMap("EMPLOYMENT_PLAN_STATUS",myData.englishDropDown['EMPLOYMENT_PLAN_STATUS']);
      this.addValueToSharedDataMap("CASE_CLOSURE_REASON",myData.englishDropDown['CASE_CLOSURE_REASON']);
      this.addValueToSharedDataMap("Client_Signing_Status",myData.englishDropDown['Client_Signing_Status']);
      this.addValueToSharedDataMap("CASE_RE_ACTIVATION_REASON",myData.englishDropDown['CASE_RE_ACTIVATION_REASON']);
      this.addValueToSharedDataMap("EMPLOYMENT_SHORT_TERM_GOAL",myData.englishDropDown['EMPLOYMENT_SHORT_TERM_GOAL']);
      this.addValueToSharedDataMap("EMPLOYMENT_LONG_TERM_GOAL",myData.englishDropDown['EMPLOYMENT_LONG_TERM_GOAL']);
      this.addValueToSharedDataMap("CASENOTE_ACTIVITY_TYPES",myData.englishDropDown['CASENOTE_ACTIVITY_TYPES']);
      this.addValueToSharedDataMap("OPT-TEXT-MSG-ALERTS", myData.englishDropDown['OPT-TEXT-MSG-ALERTS']);
      this.addValueToSharedDataMap("REIMBURSEMENTAMOUNT", myData.englishDropDown['REIMBURSEMENTAMOUNT']);
      this.addValueToSharedDataMap("ReimbReasonDesc", myData.englishDropDown['ReimbReasonDesc']);
      this.addValueToSharedDataMap("ReimbDecisionDesc", myData.englishDropDown['ReimbDecisionDesc']);
      this.addValueToSharedDataMap("ExemptionReasonsDesc", myData.englishDropDown['ExemptionReasonsDesc']);
      this.addValueToSharedDataMap("ResidenceCounties", myData.englishDropDown['ResidenceCounties']);

      this.addValueToSharedDataMap("ARIES_Income_Frequency_Type",myData.englishDropDown['ARIES_Income_Frequency_Type']);      
      this.addValueToSharedDataMap("Employment_Status_Code",myData.englishDropDown['Employment_Status_Code']);      
      this.addValueToSharedDataMap("Income_Termination_Reason_Type",myData.englishDropDown['Income_Termination_Reason_Type']);
      this.addValueToSharedDataMap("ARIES_Earned_Income_Type",myData.englishDropDown['ARIES_Earned_Income_Type']);
      this.addValueToSharedDataMap("ARIES_Unearned_Income_Type",myData.englishDropDown['ARIES_Unearned_Income_Type']);
      this.addValueToSharedDataMap("Phone_Type",myData.englishDropDown['Phone_Type']);
      this.addValueToSharedDataMap("ResidenceCounties",myData.englishDropDown['ResidenceCounties']);
      this.addValueToSharedDataMap("STATE",myData.englishDropDown['STATE']);
      this.addValueToSharedDataMap("AASIS_PAYMENT_PROCESSING_STATUS",myData.englishDropDown['AASIS_PAYMENT_PROCESSING_STATUS']);
    }
  }


  getSharedDataObject(){
    return this.sharedDataMap;
  }

  getValueFromSharedDataMap(key):any{
    return this.sharedDataMap.get(key);
  }

  addValueToSharedDataMap(key, value){
    this.sharedDataMap.set(key, value);
  }

  removeValueFromSharedDataMap(key){
    if(this.sharedDataMap.has(key)){
      this.sharedDataMap.delete(key);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/reference-table.service.ts